import { AuthenticationException } from './authentication-exception';

export class AccountNotVerifiedException extends AuthenticationException { }
